import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { PlayerMix } from '@splixer/player';
import { Pv2PlayableListComponent } from '../../menu';
import { ContentMenuItem } from '../../../models';

/**
 * Displays a list of playable links for the given list of mixes
 * No link to the associated content is provided
 */
@Component({
  selector: 'pv2-mix-list',
  templateUrl: 'mix-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [Pv2PlayableListComponent],
})
export class Pv2MixListComponent {
  public readonly items = input.required<PlayerMix[] | undefined>();
  public readonly eventSource = input.required<string>();
  public readonly displayPlayButtons = input(true, {
    transform: booleanAttribute,
  });
  public readonly displayTagLines = input(true, {
    transform: booleanAttribute,
  });
  public readonly displayDurations = input(true, {
    transform: booleanAttribute,
  });

  protected menuItems = computed(() => {
    const menuItems: ContentMenuItem[] = [];
    const items = this.items();
    if (items) {
      for (const item of items) {
        if (item.uid) {
          const mi: ContentMenuItem = {
            id: item.uid,
            name: item.name ?? 'No Name!',
            duration: item.duration,
          };
          if (this.displayPlayButtons()) {
            mi.contentId = item.uid;
          }
          if (this.displayTagLines()) {
            mi.tagLine = item.tagLine;
          }
          menuItems.push(mi);
        }
      }
    }
    return menuItems;
  });
}
